import { Box, Typography, useMediaQuery, useTheme, Drawer, IconButton, Grid, InputAdornment, CircularProgress, Stack, Hidden, Modal, TextField, Button } from '@mui/material';
import React, { useEffect, useState } from 'react'
import ScrollCouponComponent from '../../components/ScrollCouponComponent';
import PrimaryButton from '../../components/PrimaryButton';
import axios from 'axios';
import { API } from '../../utils/Api';
import ProductDrawer from '../../components/ProductDrawer';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import { CloseOutlined, ArrowBack } from '@mui/icons-material';
import Images from '../../utils/Images';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import AddonIconComponent from '../../components/AddonIconComponent';
import { useDispatch, useSelector } from 'react-redux';
import { setData } from '../../store/Cart/cartSlice';
import { setUser } from '../../store/Profile/UserSlice';
import * as Yup from 'yup';
import AuthModals from '../../components/AuthComponents/AuthModals';
import ActiveJourneyCoupons from '../../components/CouponComponents/ActiveJourneyCoupons';

const OfferScreen = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const dispatch = useDispatch();
  const outlet = localStorage.getItem("selectedStoreData");
  const token = localStorage.getItem('token');
  const deliveryType = localStorage.getItem("selectedOrderType");
  const [outletData, setOutletData] = useState(JSON.parse(localStorage.getItem('selectedStoreData')));
  const [clickableAdvertise, setClickableAdvertise] = useState([]);
  const [nonClickableAdvertise, setNonClickableAdvertise] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [open, setopen] = useState(false);
  const [selectedAddons, setSelectedAddons] = useState({});
  const [addingToCart, setAddingToCart] = useState(false);
  const outletObject = JSON.parse(outlet);
  const outletId = outletObject?._id;
  const matchesMdUp = useMediaQuery(theme.breakpoints.up('lg'));
  const [isFavorited, setIsFavorited] = useState(false);
  const [wishlistData, setWishlistData] = useState([]);
  const cartDataRedux = useSelector(state => state?.cart?.data);
  const [cartData, setCartData] = useState([]);
  const matchesMobile = useMediaQuery(theme.breakpoints.up('md'));
  const ordersType = localStorage.getItem("selectedOrderType");

  const getWishlist = async () => {
    try {
      const response = await axios.get(`${API.BASE_URL}wishlist/getUserWishlist/${outletData?._id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setWishlistData(response?.data?.data?.wishList_product_Ids);
      console.log('Wishlist in initial Screen Data', response?.data?.data?.wishList_product_Ids);
    } catch (error) {
      console.log('Wishlist Screen Error', error?.response?.data);
    }
  };

  const isProductInWishlist = (productId) => {
    return wishlistData.includes(productId);
  };

  // const handleAddonSelect = (addonId, addonValue) => {
  //   setSelectedAddons((prevSelected) => ({
  //     ...prevSelected,
  //     [addonId]: addonValue,
  //   }));
  //   // console.log('Addons', { addonId, ...addonValue });
  // };

  const handleAddonSelect = (addonId, addonValue, isMultipleSelect = false) => {
    setSelectedAddons((prevSelectedAddons) => {
      if (isMultipleSelect) {
        // Handle multiple selections
        const currentSelections = Array.isArray(prevSelectedAddons[addonId])
          ? prevSelectedAddons[addonId]
          : [];

        const isAlreadySelected = currentSelections.some(
          (selected) => selected._id === addonValue._id
        );

        const updatedSelections = isAlreadySelected
          ? currentSelections.filter((selected) => selected._id !== addonValue._id) : [...currentSelections, addonValue];

        return {
          ...prevSelectedAddons,
          [addonId]: updatedSelections,
        };
      } else {
        const isSelected = prevSelectedAddons[addonId]?._id === addonValue._id;
        const isDefault = addonValue.isDefault;

        if (isSelected && !isDefault) {
          const updatedAddons = { ...prevSelectedAddons };
          delete updatedAddons[addonId];
          return updatedAddons;
        }

        return {
          ...prevSelectedAddons,
          [addonId]: addonValue,
        };
      }
    });
  };

  useEffect(() => {
    if (!selectedProduct?.hasAddon || !selectedProduct?.addons?.length) {
      setSelectedAddons({});
      return;
    }

    const initial = {};
    selectedProduct?.addons?.forEach((addon) => {
      // find all valid defaults
      const defaults = (addon?.values || [])
        .filter(v =>
          v?.isDefault &&
          v?.status !== 'INACTIVE' &&
          !v?.excludedOutlets?.includes(outletData?._id)
        );

      if (defaults?.length) {
        if (addon?.isMultipleSelect) {
          initial[addon?._id] = defaults.map(v => ({
            ...v,
            offerPrice: v?.price ?? 0,
            mrp: v?.price ?? 0,
          }));
        } else {
          const v = defaults[0];
          initial[addon?._id] = {
            ...v,
            offerPrice: v?.price ?? 0,
            mrp: v?.price ?? 0,
          };
        }
      }
    });

    setSelectedAddons(initial);
  }, [selectedProduct, outletData]);

  const handleAddToCart = async () => {
    if (token) {
      setAddingToCart(true);
      try {
        const addonsArray = Object.keys(selectedAddons).map((addonId) => {
          const selectedAddon = selectedAddons[addonId];
          if (Array.isArray(selectedAddon)) {
            // Handle multiple selections
            return selectedAddon.map((addonValue) => ({
              _id: addonId,
              selectedValue: addonValue.value,
              addonValueId: addonValue._id,
              // Add any other fields from addonValue as required
            }));
          } else {
            // Handle single selection
            return {
              _id: addonId,
              selectedValue: selectedAddon.value,
              addonValueId: selectedAddon._id,
              // Add any other fields from selectedAddon as required
            };
          }
        });

        // Flatten the addonsArray to ensure a single array of objects
        const flattenedAddonsArray = addonsArray.flat();

        const cartItem = {
          ordersType: deliveryType,
          outlet: outletId,
          cartItems: [
            {
              product: selectedProduct._id,
              quantity: quantity,
              sourceType: "WEBSITE",
              addons: flattenedAddonsArray.length > 0 ? flattenedAddonsArray : undefined,
            }
          ],
        };

        const response = await axios.post(`${API.BASE_URL_2}cart/new`, cartItem, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        handleCloseModal();
        fetchUserCartData();
        setAddingToCart(false);
        toast.success('Product added to cart!!!');
        console.log(response.data);
      } catch (error) {
        console.error(error);
        toast.error(error?.response?.data?.error);
      } finally {
        setAddingToCart(false);
      }
    } else {
      if (matchesMdUp) {
        handleOpenAuth();
      } else {
        navigate('/mobileNumber');
      }
    }
  };

  const handleFavoriteClick = async () => {
    if (token) {
      try {
        if (isProductInWishlist(selectedProduct._id)) {
          const response = await axios.post(
            `${API.BASE_URL}wishlist/remove`,
            { productId: selectedProduct._id },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setIsFavorited(false);
          toast.success('Product removed from favorites!!!');
          console.log("Wishlist Remove Success", response.data);
          // getWishlist();
        } else {
          const response = await axios.post(
            `${API.BASE_URL}wishlist/add`,
            { productId: selectedProduct._id },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setIsFavorited(true);
          getWishlist();
          toast.success('Product added to favorites!!!');
          console.log("Wishlist Add Success", response.data);
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      if (matchesMobile) {
        // setopen(true);
        handleOpenAuth();
      } else {
        navigate('/mobileNumber');
      }
    }
  };

  const handleProductClick = (product) => {
    setSelectedProduct(product);
    setIsFavorited(isProductInWishlist(product?._id));
    console.log('Selected Product', product);
    // Set default addons
    const defaultAddons = {};
    product?.addons?.forEach((addon) => {
      const defaultValue = addon?.values?.find(value => value?.isDefault);
      if (defaultValue) {
        defaultAddons[addon._id] = {
          ...defaultValue,
          offerPrice: defaultValue.offerPrice ?? 0,
          mrp: defaultValue.mrp ?? 0,
        };
      }
    });
    setSelectedAddons(defaultAddons);
  };

  const handleCloseModal = () => {
    setSelectedProduct(null);
    setQuantity(1);
    setSelectedAddons({});
  };

  // const handleAddToCart = async () => {
  //   if (token) {
  //     setAddingToCart(true);
  //     try {
  //       const addonsArray = Object.keys(selectedAddons).map((addonId) => ({
  //         _id: addonId,
  //         selectedValue: selectedAddons[addonId].value,
  //         addonValueId: selectedAddons[addonId]._id,
  //       }));
  //       const cartItem = {
  //         ordersType: deliveryType,
  //         outlet: outletId,
  //         cartItems: [
  //           {
  //             product: selectedProduct._id,
  //             quantity: quantity,
  //             addons: addonsArray.length > 0 ? addonsArray : undefined,
  //           }
  //         ],
  //       };
  //       const response = await axios.post(`${API.BASE_URL}cart`, cartItem, {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });
  //       handleCloseModal();
  //       fetchUserCartData();
  //       setAddingToCart(false);
  //       toast.success('Product added to cart!!!');
  //       console.log(response.data);
  //     } catch (error) {
  //       console.error(error);
  //     } finally {
  //       setAddingToCart(false);
  //     }
  //   } else {
  //     if (matchesMdUp) {
  //       setopen(true);
  //     } else {
  //       navigate('/mobileNumber');
  //     }
  //   }
  // };

  const fetchUserCartData = async () => {
    try {
      const response = await axios.get(`${API.BASE_URL_2}cart/userCart/new/${outletData._id}/${deliveryType}?source=WEBSITE`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(setData(response?.data));
      setCartData(cartDataRedux);
      // console.log('cartDataRedux', cartDataRedux);
      console.log('Cart Screen Data', response?.data?.data?.cartItems);
    } catch (error) {
      dispatch(setData([]));
      console.log('Cart Screen Error', error?.response?.data);
    }
  };

  const getAdvertisments = async () => {
    const url = outletData && outletData._id
      ? `${API.BASE_URL}advertisement/user/new?outletId=${outletData._id}&orderType=${ordersType}`
      : `${API.BASE_URL}advertisement/user/new?orderType=${ordersType}`;
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setNonClickableAdvertise(response?.data?.data?.advertisements?.nonClickableAdvertisements);
      setClickableAdvertise(response?.data?.data?.advertisements?.clickableAdvertisements);
    } catch (error) {
      console.log("Error in getting Ads", error?.response);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getAdvertisments();
    // getWishlist();
  }, []);

  const handleIncreaseQuantity = () => {
    setQuantity((prevQuantity) => prevQuantity + 1);
  };

  const handleDecreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity((prevQuantity) => prevQuantity - 1);
    }
  };

  const [totalPrice, setTotalPrice] = useState(selectedProduct?.newOfferPrice || 0);
  const [totalMrpPrice, setTotalMrpPrice] = useState(selectedProduct?.newMrp || 0);
  const [offerPercentage, setOfferPercentage] = useState(0);

  useEffect(() => {
    let calculateTotalPrice = () => {
      let price = selectedProduct?.newOfferPrice ?? 0;
      let mrp = selectedProduct?.newMrp ?? 0;
      Object.values(selectedAddons).forEach(addon => {
        if (Array.isArray(addon)) {
          addon.forEach(val => {
            price += val?.offerPrice ?? val?.price ?? 0;
            mrp += val?.mrp ?? val?.price ?? 0;
          });
        } else if (addon && typeof addon === 'object') {
          price += addon?.offerPrice ?? addon?.price ?? 0;
          mrp += addon?.mrp ?? addon?.price ?? 0;
        }
      });
      setTotalPrice(price);
      setTotalMrpPrice(mrp);
    };
    calculateTotalPrice();
  }, [selectedAddons, selectedProduct]);

  useEffect(() => {
    if (totalMrpPrice > 0 && totalPrice < totalMrpPrice) {
      const discount = ((totalMrpPrice - totalPrice) / totalMrpPrice) * 100;
      setOfferPercentage(discount);
    } else {
      setOfferPercentage(0);
    }
  }, [totalPrice, totalMrpPrice]);

  const [isModalOpen, setModalOpen] = useState(false);

  const handleOpenAuth = () => {
    setModalOpen(true);
  }

  const handleCloseAuth = () => {
    setModalOpen(false);
  }

  return (
    <>
      <Box className="offerScreen" minHeight={'100vh'}>
        <Hidden smUp>
          <Box className="title">
            <Typography variant='h6' className="titleText">OFFERS</Typography>
          </Box>
        </Hidden>
        <Hidden smUp>
          <Box mx={1}>
            <ActiveJourneyCoupons />
          </Box>
        </Hidden>
        <>
          {clickableAdvertise?.filter(ad => {
            const isValidOutlet = outletData?.isEventOutlet || !ad?.product?.isEventProduct;
            const today = new Date().toISOString();
            const hasValidDates =
              (!ad?.validityStartDate || ad?.validityStartDate <= today) &&
              (!ad?.validityEndDate || ad?.validityEndDate >= today);
            const isActive = ad?.product?.status !== 'INACTIVE';
            const isNotExcluded = !ad?.excludedOutlets?.includes(outletData?._id);
            const isCategoryNotExcluded = !ad?.product?.category?.excludedOutlets?.includes(outletData?._id);
            return isValidOutlet && hasValidDates && isActive && isNotExcluded && isCategoryNotExcluded;
          })
            .map((ad, index) => (
              <div className='adImageBox' key={index}>
                <img loading='lazy' className="adImage" onClick={() => handleProductClick(ad?.product)} src={ad?.adImagePath} alt={`Advertisement ${index}`} />
              </div>
            ))}

          {nonClickableAdvertise?.filter(ad => {
            const isNotTopOrBottomImage = !ad?.isTopImage && !ad?.isBottomImage;
            const today = new Date().toISOString();
            const isValidDate =
              (!ad?.validityStartDate || ad?.validityStartDate <= today) &&
              (!ad?.validityEndDate || ad?.validityEndDate >= today);
            const isNotExcluded = !ad?.excludedOutlets?.includes(outletData?._id);
            return isNotTopOrBottomImage && isValidDate && isNotExcluded;
          })
            .map((ad, index) => (
              <div className='adImageBox' key={index}>
                <img loading='lazy' className="adImage" onClick={() => navigate('/productsListing')} src={ad?.adImagePath} alt={`Advertisement ${index}`} />
              </div>
            ))}

        </>
      </Box>
      <ProductDrawer
        open={!!selectedProduct}
        onClose={handleCloseModal}
        selectedProduct={selectedProduct}
        handleAddToCart={handleAddToCart}
        isFavorited={isFavorited}
        handleFavoriteClick={handleFavoriteClick}
        quantity={quantity}
        handleIncreaseQuantity={handleIncreaseQuantity}
        handleDecreaseQuantity={handleDecreaseQuantity}
        selectedAddons={selectedAddons}
        handleAddonSelect={handleAddonSelect}
        totalPrice={totalPrice}
        totalMrpPrice={totalMrpPrice}
        offerPercentage={offerPercentage}
        addingToCart={addingToCart}
      />
      <AuthModals openAuth={isModalOpen} handleCloseAuth={handleCloseAuth} />
    </>
  )
}

export default OfferScreen;
